import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Utils
import { useUniqueId } from 'src/hooks'
import { pushToWindowResize } from 'src/helpers/browser'

// Components
import { If, Button } from 'src/Components'

// Styles
import styles from './Chart.module.scss'

const propTypes = {
  show: PropTypes.bool,
  children: PropTypes.object,
  handleClose: PropTypes.func
}

const ToolTip = React.forwardRef((props, ref) => {
  const { show, children, handleClose } = props

  const identifier = useUniqueId('AVM_Chart_Tip_')
  const [posStyle, setPosStyle] = useState({})

  const calculatePosition = () => {
    if (ref.current) {
      const datapoints = [
        ...ref.current.querySelectorAll('.datapoint circle[cx].point')
      ]
      if (datapoints.length) {
        const pos = {
          left: `${datapoints[datapoints.length - 1].getAttribute('cx')}px`,
          top: `${datapoints[datapoints.length - 1].getAttribute('cy')}px`
        }
        if (pos.left !== posStyle.left || pos.top !== posStyle.top) {
          setPosStyle(pos)
        }
      }
    }
  }

  useEffect(calculatePosition)

  pushToWindowResize(identifier, () => {
    setTimeout(calculatePosition, 500)
  })

  return (
    <If condition={show}>
      <div data-qa='tool-tip-wrapper' className={styles.tooltipWrapper}>
        <div className={styles.tooltip} style={posStyle}>
          <div className={styles.content}>
            <Button.Close
              data-qa='tool-tip-close-btn'
              className={styles.close}
              onClick={() => handleClose()}
            />
            {children}
          </div>
        </div>
      </div>
    </If>
  )
})

ToolTip.propTypes = propTypes
export default ToolTip
